// removed by extract-text-webpack-plugin
module.exports = {"footer":"I8U-lCbQSorYYtSG0EhvG","footer-container":"iV37zDsFAQoffECQpl2yj","footer-p":"_1hfzu9lI1jaTCrwGVXPywt","social-container":"_3_rkDihpPB3wJXN77UhpTi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/Footer.scss
// module id = 1198
// module chunks = 47